import { mapGetters } from 'vuex';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';
import ConfirmDialog from '@/view/pages/ConfirmDialog';
import SwfApiService from '@/core/services/api.service.swf';
export default {
  props: {
    modal: {
      default: false
    },
    value: Boolean
  },

  name: 'swf-configuration',
  data() {
    return {
      alertSuccess: false,
      alertError: false,
      valid: false,
      isSaving: false,
      request: {
        minimalDiscount: null,
        sessionLengthInSeconds: null
      },
      requiredRule: [v => !!v || 'Field is required']
    };
  },
  async created() {
    this.loading = true;
    this.$log.debug('await init swf service - start');
    await SwfApiService.init();
    this.$log.debug('await init swf service - end');
    this.swfApiInitiated = true;
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Shopping with friends configuration' }]);
    this.loadConfiguration();
  },
  components: {
    ConfirmDialog
  },
  mounted: function() {
    if (this.alertSuccess || this.alertError) {
      this.hide_alert();
    }
  },
  watch: {
    alertSuccess(new_val) {
      if (new_val) {
        setTimeout(() => {
          this.alertSuccess = false;
        }, 3000);
      }
    },
    alertError(new_val) {
      if (new_val) {
        setTimeout(() => {
          this.alertError = false;
        }, 3000);
      }
    }
  },
  methods: {
    validateAndSave() {
      if (this.$refs.form.validate()) {
        this.sentRequestPopup(this.request);
      }
    },
    async sentRequestPopup(request) {
      if (
        await this.$refs.confirm.open(
          this.$i18n.t('common.confirm'),
          'Are you sure you want to update SWF configuration ?'
        )
      ) {
        this.sendRequest(request);
      }
    },
    clearForm() {
      this.$refs.form.reset();
    },
    previousState() {
      this.$router.go(-1);
    },
    endsWith(suffix, str) {
      return str.indexOf(suffix, str.length - suffix.length) !== -1;
    },
    paddingSize(value) {
      if (this.endsWith('==', value)) {
        return 2;
      }
      if (this.endsWith('=', value)) {
        return 1;
      }
      return 0;
    },
    loadConfiguration() {
      return new Promise(resolve => {
        this.loading = true;
        SwfApiService.query('/admin-panel/config').then(response => {
          // JSON responses are automatically parsed.
          this.$log.debug('Swf configuration: ', response.data);
          this.request.minimalDiscount = response.data.minimalDiscount;
          this.request.sessionLengthInSeconds = response.data.sessionLengthInSeconds;
          this.loading = false;
          resolve();
        });
      });
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains('navi-link')) {
        target = event.target.closest('.navi-link');
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll('.navi-link');
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove('active');
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute('data-tab'));

      // set current active tab
      target.classList.add('active');
    },
    sendRequest(request) {
      this.isSaving = true;
      this.loading = true;
      SwfApiService.post(`/admin-panel/config`, request)
        .then(response => {
          this.$log.debug('Request sent: ' + response);
          this.alertSuccess = true;
        })
        .catch(error => {
          this.$log.error('Error: ', error);
          this.errored = true;
          this.alertError = true;
        })
        .finally(() => {
          this.loading = false;
          this.isSaving = false;
          this.loadConfiguration();
        });
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    ...mapGetters(['currentUserPersonalInfo']),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.$emit('input', value);
        }
      }
    }
  }
};
